// shared/constants.ts: input caps, timings and lifetimes shared by the SPA and the Worker (spec 10.5, VERBATIM values).
export const LIMITS = {
  nameChars: 120, titleChars: 120, noteChars: 1000, commentChars: 2000, messageChars: 4000, roomAnswerChars: 2000,
  customRoomNameChars: 40, relationNoteChars: 60, firmChars: 80, inviteMessageChars: 1000, locationChars: 200,
  intakeNotesChars: 4000, correctionChars: 1000, jsonBodyBytes: 64 * 1024, assistantBodyBytes: 32 * 1024,
  photoBytesMax: 15 * 1024 * 1024, photoBatchMax: 20, photosPerProject: 300,
  photosUnverified: 24,                 // uploads per project by an unverified uploader, deleted ones included
  clientResizeEdge: 2400, clientResizeQuality: 0.85,
  peoplePerProject: 10, invitesPerProjectPerDay: 20, inviteResendsMax: 3, customRoomsMax: 12,
  signinTokensConcurrent: 3, signinLinksPerEmailIpPerHour: 3, signinLinksPerEmailPerHour: 10, verifyEmailsPerUserPerDay: 3,
  emailsPerRecipientPerDay: 12,
  refsPerMessage: 5, filesPerMessage: 5, fileBytesMax: 25 * 1024 * 1024, timeOptionsMax: 4, timeOptionsMaxDays: 60, fileEntriesMax: 50,
  briefsPerProjectPerDay: 20, assistantTurnsMax: 12, assistantMessageChars: 1000,
  reflectionMinUserReactions: 3, reflectionCooldownMs: 60_000,
  uploadsPerUserPerDay: 200, uploadsPerProjectPerDay: 300, uploadBytesPerUserPerDay: 1024 * 1024 * 1024,
  classifyPerProjectPerDay: 150, reflectPerProjectPerDay: 60, reflectPerUserPerDay: 40,
  projectShareOfTenantCap: 0.2, usageAlertAt: 0.8,
  // Start Your Build (docs/onsite/ONSITE.md 4.1, 4.6, 5.4; DECISIONS "Start Your Build: contract additions")
  startPerIpPerHour: 10,                // then challenge_required (interactive Turnstile) instead of a 429
  startHardPerIpPerHour: 30,            // the hard ceiling: 429
  startPerEmailPerDay: 3,               // household emails a day from /api/start to one address
  existingPerIpPerDay: 3,               // "existing" outcomes per IP a day before challenge_required
  startBodyBytes: 16 * 1024,
  emailChangesMax: 2, codeTries: 5,
  intakeSessionAbsoluteMs: 7 * 864e5, embedHandoffTtlMs: 2 * 6e4,
} as const;
export const PHOTO_TYPES = ["image/jpeg", "image/png", "image/webp", "image/heic", "image/heif", "image/avif"] as const;
/**
 * What a message can carry (docs/DECISIONS.md "Message attachments"): photos (stored as their resized variants, like a
 * board photo), PDFs, and Word and Excel files (stored as sent, always downloaded, never shown inline).
 */
export const MESSAGE_FILE_TYPES = [
  ...PHOTO_TYPES,
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
] as const;
export const MODEL_IMAGE_TYPES = ["image/jpeg", "image/png", "image/webp", "image/gif"] as const;
export const POLL_MS = { thread: 4000, sorting: 4000, idle: 15000, team: 30000 } as const;
export const PRESENCE_WINDOW_MS = 60_000;
export const PRESENCE_WRITE_MS = 30_000;
export const VISIT_GAP_MS = 30 * 60_000;
export const NOTIFY_DEBOUNCE_MS = { messages: 120_000, activity: 1_800_000, demo: 10_000 } as const;
export const SESSION_MS = {
  memberSliding: 30 * 864e5, memberAbsolute: 90 * 864e5, staffSliding: 14 * 864e5, staffAbsolute: 30 * 864e5,
  demoAbsolute: 8 * 36e5, limitedNotifyAbsolute: 24 * 36e5, limitedLinkSliding: 14 * 864e5, limitedLinkAbsolute: 30 * 864e5,
} as const;
export const TOKEN_TTL_MS = { signin: 20 * 6e4, welcome: 7 * 864e5, handoff: 30 * 6e4, notify: 72 * 36e5, invite: 7 * 864e5, teamInvite: 72 * 36e5, verify: 7 * 864e5 } as const;
